import { Injectable } from '@angular/core';

import { FilterService } from '../core/services';

import { DropdownValue } from './dropdown.model';
import { TreeSelectionModel } from './tree-selection.model';
import { PublisherGroupModel } from '../core/services/publisher-group.model';
import { BrandModel } from '../shared/brand.model';

@Injectable()
export class FilterItemsService {
    private static countries = 'countries';
    private static providers = 'providerss';

    constructor(private filterService: FilterService) {
    }

    public getCountries(addAllValue: boolean): Array<DropdownValue> {
        let result = Array<DropdownValue>();
        let countryValues = this.filterService.getCountries();

        if (countryValues.length > 0) {
            if (countryValues.length > 1 && addAllValue)
                result.push(new DropdownValue(0, "All"));
            for (let country of countryValues)
                result.push(new DropdownValue(country.id, country.countryName));
        }

        return result;
    }

    public getCountryIds(): Array<number> {
        return this.filterService.getCountryIds();
    }

    public getDefaultCountrySelection(addAllValue: boolean): DropdownValue {
        let items = this.getCountries(addAllValue);
        if (items.length > 0)
            return new DropdownValue(items[0].value, items[0].label);
    }

    public getProviders(addAllValue: boolean): Array<DropdownValue> {
        let result = Array<DropdownValue>();
        let providers = this.filterService.getProviders();

        if (providers.length > 0) {
            if (providers.length > 1 && addAllValue)
                result.push(new DropdownValue(0, "All"));
            for (let provider of providers)
                result.push(new DropdownValue(provider.id, provider.name));
        }

        return result;
    }

    public getNonConfigurableProviders(addAllValue: boolean): Array<DropdownValue> {
        let result = Array<DropdownValue>();
        let providers = this.filterService.getNonConfigurableProviders();

        if (providers.length > 0) {
            if (providers.length > 1 && addAllValue)
                result.push(new DropdownValue(0, "All"));
            for (let provider of providers)
                result.push(new DropdownValue(provider.id, provider.name));
        }

        return result;
    }


    public getProvidersIds(): Array<number> {
        return this.filterService.getProviderIds();
    }

    public getNonConfigurableProvidersIds(): Array<number> {
        let providerIds = Array<number>();
        let providers = this.filterService.getNonConfigurableProviders();
        for (let provider of providers)
            providerIds.push(provider.id);
        return providerIds;
    }

    public getDefaultProviderSelection(addAllValue: boolean): DropdownValue {
        let items = this.getProviders(addAllValue);
        if (items.length > 0)
            return new DropdownValue(items[0].value, items[0].label);
    }

    public getDefaultNonConfigurableProviderSelection(addAllValue: boolean): DropdownValue {
        let items = this.getNonConfigurableProviders(addAllValue);
        if (items.length > 0)
            return new DropdownValue(items[0].value, items[0].label);
    }

    public getPublishers(): Array<TreeSelectionModel> {
        let result = Array<TreeSelectionModel>();
        let publishers = this.filterService.getPublishers();

        if (publishers.length > 0) {
            for (let publisher of publishers)
                result.push(new TreeSelectionModel(publisher.id, publisher.name, publisher.group, true));
        }
        return result.sort((p1,p2) => p1.label.toLowerCase() > p2.label.toLowerCase() ? 1 : -1);
    }

    public getPublisherGroups(): Array<PublisherGroupModel> {
        let result = Array<PublisherGroupModel>();
        let groups = this.filterService.getPublisherGroups();

        if (groups.length > 0) {
            return groups;
        }
        return result;
    }

    public getBrands(): Array<BrandModel> {
        let result = Array<BrandModel>();
        let groups = this.filterService.getBrands();

        if (groups.length > 0) {
            return groups;
        }
        return result;
    }

    public getProvidersTreeViewModel(): Array<TreeSelectionModel> {
        let result = Array<TreeSelectionModel>();
        let providers = this.filterService.getNonConfigurableProviders();

        if (providers.length > 0) {
            for (let provider of providers)
                result.push(new TreeSelectionModel(provider.id, provider.name, 'Provider', true));
        }
        return result;
    }

    public getPublishersIds(): Array<number> {
        return this.filterService.getPublisherIds();
    }


    public getPeriods(): Array<DropdownValue> {
        return [
            new DropdownValue(1, 'Today'),
            new DropdownValue(2, 'Yesterday'),
            new DropdownValue(3, 'This week'),
            new DropdownValue(4, 'Last week'),
            new DropdownValue(5, 'This month'),
            new DropdownValue(6, 'Last month'),
            new DropdownValue(7, 'Last 7 days'),
            new DropdownValue(8, 'Last 30 days'),
            new DropdownValue(9, 'Custom'),
            new DropdownValue(10, 'Max')];
    }

    public getMinValueSelected(value: number): Date {
        switch (value) {
            case 1:
                return this.utcDate(new Date());
            case 2:
                var yestarday = new Date();
                yestarday.setDate(yestarday.getDate() - 1);
                return this.utcDate(yestarday);
            case 3:
                var today = new Date();
                var first = today.getDate() - today.getDay() + 1;
                return this.utcDate(new Date(today.setDate(first)));
            case 4:
                var today = new Date();
                var first = today.getDate() - today.getDay() - 6;
                return this.utcDate(new Date(today.setDate(first)));
            case 5:
                var today = new Date();
                return this.utcDate(new Date(today.setDate(1)));
            case 6:
                var today = new Date();
                today.setDate(0);
                today.setDate(1);
                return this.utcDate(today);
            case 7:
                var today = new Date();
                var first = today.getDate() - 6;
                return this.utcDate(new Date(today.setDate(first)));
            case 8:
                var today = new Date();
                var first = today.getDate() - 30;
                return this.utcDate(new Date(today.setDate(first)));
            case 10:
                var today = new Date();
                var first = today.getDate() - 60;
                return this.utcDate(new Date(today.setDate(first)));
            default:
                return this.utcDate(new Date())
        }
    }

    public getMaxValueSelected(value: number): Date {
        switch (value) {
            case 1:
                return this.utcDate(new Date());
            case 2:
                var yestarday = new Date();
                yestarday.setDate(yestarday.getDate() - 1);
                return this.utcDate(yestarday);
            case 3:
                return this.utcDate(new Date());
            case 4:
                var today = new Date();
                var first = today.getDate() - today.getDay();
                return this.utcDate(new Date(today.setDate(first)));
            case 5:
                return this.utcDate(new Date());
            case 6:
                var today = new Date();
                today.setDate(0);
                return this.utcDate(today);
            case 7:
                var today = new Date();
                return this.utcDate(new Date());
            case 8:
                var today = new Date();
                return this.utcDate(new Date());
            case 10:
                var today = new Date();
                return this.utcDate(new Date());
            default:
                return this.utcDate(new Date())
        }
    }

    public getDefaultPeriodSelection(): DropdownValue {
        return this.getPeriods()[7];
    }

    private utcDate(date: Date): Date {
        var _utc = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return _utc;
    }

    public getAvailableValues(): Array<DropdownValue> {
        return [
            new DropdownValue(1, 'Is Available'),
            new DropdownValue(2, 'Is Not Available'),
            new DropdownValue(3, 'Both')
        ]
    }

    public getDefaultIsAvailableSelection(): DropdownValue {
        return this.getAvailableValues()[0];
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/filter-items.service.ts